import { render, staticRenderFns } from "./BreathAnalysis.vue?vue&type=template&id=80bd49d4&scoped=true&"
import script from "./BreathAnalysis.vue?vue&type=script&lang=ts&"
export * from "./BreathAnalysis.vue?vue&type=script&lang=ts&"
import style0 from "./BreathAnalysis.vue?vue&type=style&index=0&id=80bd49d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80bd49d4",
  null
  
)

export default component.exports